<template>
  <article class="post">
    <div class="post_banner" v-if="post">
      <img :src="`/s/${post.image}`" alt="">
    </div>
    <div class="post_content base_content">
      <div class="post_title base_title">Новость</div>
      <div class="post_content-body" v-if="post">
        <div class="post_content-title">{{ post.title }}</div>
        <div class="post_content-text" v-html="post.full"></div>
      </div>
    </div>
  </article>
</template>
<script>
import Backend from '../services/backend.service';

export default {
  name: 'Post',
  data() {
    return {
      backend: new Backend(),
      uid: null,
      post: null,
    };
  },
  methods: {
    gatherPostInfo() {
      this.backend.get(`/post/${this.uid}`)
        .then((resp) => {
          this.post = resp;
          console.log(this.post);
        })
        .catch(err => console.error(err));
    },
  },
  computed: {
  },
  mounted() {
    this.uid = this.$route.params.uid;
    this.gatherPostInfo();
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/variables.scss";
.post{
  &_banner{
    aspect-ratio: 16/8;
    width: 100%;
    pointer-events: none;
    img{
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Post.vue